var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWind(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 51.51,
    height: 42.26,
    viewBox: "0 0 51.51 42.26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0,21.13h39.44c7.32,0,12.06-5.8,12.06-11.99,0-5.15-3.38-9.14-9.04-9.14s-9.05,4.65-9.05,8.95c0,3.67,2.43,6.14,6.03,6.14,3.33,0,6.04-2.71,6.04-6.04h-3.02c0,1.66-1.35,3.02-3.02,3.02-2.62,0-3.02-1.95-3.02-3.12,0-2.39,1.92-5.94,6.03-5.94,4.44,0,6.03,3.16,6.03,6.12,0,4.35-3.17,8.97-9.04,8.97H0v3.02Z",
    fill: "#f0f0f0",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m33.4,34.65c0-5.36-4.2-10.5-10.56-10.5H0v3.02h22.84c5.2,0,7.54,4.38,7.54,7.49,0,1.31-.39,2.46-1.09,3.26-.78.88-1.94,1.33-3.43,1.33-3.08,0-4.52-2.59-4.52-4.35,0-1.08.45-1.69,1.5-1.69.83,0,1.51.68,1.51,1.51h3.02c0-2.5-2.03-4.53-4.53-4.53-2.77,0-4.52,2-4.52,4.71,0,3.54,2.88,7.37,7.54,7.37,5.21,0,7.54-3.82,7.54-7.61Z",
    fill: "#f0f0f0",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.04,12.07h15.29v3.02H6.04v-3.02Z",
    fill: "#f0f0f0",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.04,30.18h9.26v3.02H6.04v-3.02Z",
    fill: "#f0f0f0",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m33.4,24.15h12.07v3.02h-12.07v-3.02Z",
    fill: "#f0f0f0",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.35,12.07h3.02v3.02h-3.02v-3.02Z",
    fill: "#f0f0f0",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0,12.07h3.02v3.02H0v-3.02Z",
    fill: "#f0f0f0",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0,30.18h3.02v3.02H0v-3.02Z",
    fill: "#f0f0f0",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m48.49,24.15h3.02v3.02h-3.02v-3.02Z",
    fill: "#f0f0f0",
    strokeWidth: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWind);
export default __webpack_public_path__ + "static/media/wind.6df8afe55bf13906afe04d5a3843d959.svg";
export { ForwardRef as ReactComponent };